"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __reExport = (target, mod, secondTarget) => (__copyProps(target, mod, "default"), secondTarget && __copyProps(secondTarget, mod, "default"));
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target, mod));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  ChakraProvider: () => ChakraProvider,
  extendTheme: () => extendTheme,
  mergeThemeOverride: () => mergeThemeOverride,
  withDefaultColorScheme: () => withDefaultColorScheme,
  withDefaultProps: () => withDefaultProps,
  withDefaultSize: () => withDefaultSize,
  withDefaultVariant: () => withDefaultVariant
});
module.exports = __toCommonJS(src_exports);

// ../../../react-shim.js
var import_react = __toESM(require("react"));

// src/index.ts
__reExport(src_exports, require("@chakra-ui/accordion"), module.exports);
__reExport(src_exports, require("@chakra-ui/alert"), module.exports);
__reExport(src_exports, require("@chakra-ui/avatar"), module.exports);
__reExport(src_exports, require("@chakra-ui/breadcrumb"), module.exports);
__reExport(src_exports, require("@chakra-ui/button"), module.exports);
__reExport(src_exports, require("@chakra-ui/checkbox"), module.exports);
__reExport(src_exports, require("@chakra-ui/close-button"), module.exports);
__reExport(src_exports, require("@chakra-ui/control-box"), module.exports);
__reExport(src_exports, require("@chakra-ui/counter"), module.exports);
__reExport(src_exports, require("@chakra-ui/css-reset"), module.exports);
__reExport(src_exports, require("@chakra-ui/editable"), module.exports);
__reExport(src_exports, require("@chakra-ui/form-control"), module.exports);
__reExport(src_exports, require("@chakra-ui/hooks"), module.exports);
__reExport(src_exports, require("@chakra-ui/icon"), module.exports);
__reExport(src_exports, require("@chakra-ui/image"), module.exports);
__reExport(src_exports, require("@chakra-ui/input"), module.exports);
__reExport(src_exports, require("@chakra-ui/layout"), module.exports);
__reExport(src_exports, require("@chakra-ui/media-query"), module.exports);
__reExport(src_exports, require("@chakra-ui/menu"), module.exports);
__reExport(src_exports, require("@chakra-ui/modal"), module.exports);
__reExport(src_exports, require("@chakra-ui/number-input"), module.exports);
__reExport(src_exports, require("@chakra-ui/pin-input"), module.exports);
__reExport(src_exports, require("@chakra-ui/popover"), module.exports);
__reExport(src_exports, require("@chakra-ui/popper"), module.exports);
__reExport(src_exports, require("@chakra-ui/portal"), module.exports);
__reExport(src_exports, require("@chakra-ui/progress"), module.exports);
__reExport(src_exports, require("@chakra-ui/radio"), module.exports);
__reExport(src_exports, require("@chakra-ui/react-env"), module.exports);
__reExport(src_exports, require("@chakra-ui/select"), module.exports);
__reExport(src_exports, require("@chakra-ui/skeleton"), module.exports);
__reExport(src_exports, require("@chakra-ui/slider"), module.exports);
__reExport(src_exports, require("@chakra-ui/spinner"), module.exports);
__reExport(src_exports, require("@chakra-ui/stat"), module.exports);
__reExport(src_exports, require("@chakra-ui/switch"), module.exports);
__reExport(src_exports, require("@chakra-ui/system"), module.exports);
__reExport(src_exports, require("@chakra-ui/table"), module.exports);
__reExport(src_exports, require("@chakra-ui/tabs"), module.exports);
__reExport(src_exports, require("@chakra-ui/tag"), module.exports);
__reExport(src_exports, require("@chakra-ui/textarea"), module.exports);
__reExport(src_exports, require("@chakra-ui/theme"), module.exports);
__reExport(src_exports, require("@chakra-ui/toast"), module.exports);
__reExport(src_exports, require("@chakra-ui/tooltip"), module.exports);
__reExport(src_exports, require("@chakra-ui/transition"), module.exports);
__reExport(src_exports, require("@chakra-ui/visually-hidden"), module.exports);

// src/chakra-provider.tsx
var import_provider = require("@chakra-ui/provider");
var import_theme = require("@chakra-ui/theme");
var import_toast = require("@chakra-ui/toast");
function ChakraProvider({
  children,
  theme: theme2 = import_theme.theme,
  toastOptions,
  ...restProps
}) {
  return /* @__PURE__ */ import_react.default.createElement(import_provider.ChakraProvider, {
    theme: theme2,
    ...restProps
  }, children, /* @__PURE__ */ import_react.default.createElement(import_toast.ToastProvider, {
    ...toastOptions
  }));
}

// src/extend-theme.ts
var import_theme2 = require("@chakra-ui/theme");
var import_utils = require("@chakra-ui/utils");
function extendTheme(...extensions) {
  let overrides = [...extensions];
  let baseTheme = extensions[extensions.length - 1];
  if ((0, import_theme2.isChakraTheme)(baseTheme) && overrides.length > 1) {
    overrides = overrides.slice(0, overrides.length - 1);
  } else {
    baseTheme = import_theme2.theme;
  }
  return (0, import_utils.pipe)(...overrides.map((extension) => (prevTheme) => (0, import_utils.isFunction)(extension) ? extension(prevTheme) : mergeThemeOverride(prevTheme, extension)))(baseTheme);
}
function mergeThemeOverride(...overrides) {
  return (0, import_utils.mergeWith)({}, ...overrides, mergeThemeCustomizer);
}
function mergeThemeCustomizer(source, override, key, object) {
  if (((0, import_utils.isFunction)(source) || (0, import_utils.isFunction)(override)) && Object.prototype.hasOwnProperty.call(object, key)) {
    return (...args) => {
      const sourceValue = (0, import_utils.isFunction)(source) ? source(...args) : source;
      const overrideValue = (0, import_utils.isFunction)(override) ? override(...args) : override;
      return (0, import_utils.mergeWith)({}, sourceValue, overrideValue, mergeThemeCustomizer);
    };
  }
  return void 0;
}

// src/theme-extensions/with-default-color-scheme.ts
var import_utils2 = require("@chakra-ui/utils");
function withDefaultColorScheme({
  colorScheme,
  components
}) {
  return (theme2) => {
    let names = Object.keys(theme2.components || {});
    if (Array.isArray(components)) {
      names = components;
    } else if ((0, import_utils2.isObject)(components)) {
      names = Object.keys(components);
    }
    return mergeThemeOverride(theme2, {
      components: (0, import_utils2.fromEntries)(names.map((componentName) => {
        const withColorScheme = {
          defaultProps: {
            colorScheme
          }
        };
        return [componentName, withColorScheme];
      }))
    });
  };
}

// src/theme-extensions/with-default-size.ts
var import_utils3 = require("@chakra-ui/utils");
function withDefaultSize({
  size,
  components
}) {
  return (theme2) => {
    let names = Object.keys(theme2.components || {});
    if (Array.isArray(components)) {
      names = components;
    } else if ((0, import_utils3.isObject)(components)) {
      names = Object.keys(components);
    }
    return mergeThemeOverride(theme2, {
      components: (0, import_utils3.fromEntries)(names.map((componentName) => {
        const withSize = {
          defaultProps: {
            size
          }
        };
        return [componentName, withSize];
      }))
    });
  };
}

// src/theme-extensions/with-default-variant.ts
var import_utils4 = require("@chakra-ui/utils");
function withDefaultVariant({
  variant,
  components
}) {
  return (theme2) => {
    let names = Object.keys(theme2.components || {});
    if (Array.isArray(components)) {
      names = components;
    } else if ((0, import_utils4.isObject)(components)) {
      names = Object.keys(components);
    }
    return mergeThemeOverride(theme2, {
      components: (0, import_utils4.fromEntries)(names.map((componentName) => {
        const withVariant = {
          defaultProps: {
            variant
          }
        };
        return [componentName, withVariant];
      }))
    });
  };
}

// src/theme-extensions/with-default-props.ts
var import_utils5 = require("@chakra-ui/utils");
function withDefaultProps({
  defaultProps: { colorScheme, variant, size },
  components
}) {
  const identity = (t) => t;
  const fns = [
    colorScheme ? withDefaultColorScheme({ colorScheme, components }) : identity,
    size ? withDefaultSize({ size, components }) : identity,
    variant ? withDefaultVariant({ variant, components }) : identity
  ];
  return (theme2) => mergeThemeOverride((0, import_utils5.pipe)(...fns)(theme2));
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  ChakraProvider,
  extendTheme,
  mergeThemeOverride,
  withDefaultColorScheme,
  withDefaultProps,
  withDefaultSize,
  withDefaultVariant
});
